/* eslint-disable camelcase */
export const self_reject = {
  'your-answer-has-been-received': 'Рахмат! Сиздин жообуңуз жаздырылды',
  'do-you-want-reject-vacancy': 'Вакансиядан баш тартууну каалайсызбы?',
  'choose-reject-reason': 'Баш тартуунун себебин тандаңыз',
  'reject-reason': 'Баш тартуунун себеби',
  'to-reject': 'Баш тартуу',
};
